import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  //HEADER//
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };
  //comentario
  //DOMAINS///http://127.0.0.1:8000/
  //private domain: string = "http://127.0.0.1:8000/";
  private domain: string = "https://gamesfornews.convoca.pe/";
  //private domain: string = "https://dev-dashboard.gamesfornews.com/";
  //private domain: string = "https://gamesfornews.convoca.pe/";

  //ENDPOINTS//
  private endPointUser: string = `${this.domain}api/signin`;
  private endPointTerms: string = `${this.domain}api/usuario_actualizarterminos`;
  private endPointProfile: string = `${this.domain}api/usuario_list`;
  private endPointUpdateProfile: string = `${this.domain}api/usuario_update`;

  // GAME  ENDPOINTS
  private endPointCreateGame: string = `${this.domain}api/juego_create`;
  private endPointListGames: string = `${this.domain}api/juego_list`;
  private endPointCloneGames: string = `${this.domain}api/juego_duplicate`;
  private endPointDeleteGame: string = `${this.domain}api/juego_delete`;

  private endPointDesignGeneralGame: string = `${this.domain}api/disenio_general_list`;
  private endPointFontsGame: string = `${this.domain}api/fuentes_list`;
  private endPointStyleFontsGame: string = `${this.domain}api/estilo_fuentes_list`;
  private endPointSizeFontsGame: string = `${this.domain}api/tamanio_fuentes_list`;
  private endPointUpdateDesignGeneralGame: string = `${this.domain}api/disenio_general_update`;
  private endPointUpdateFondoImage: string = `${this.domain}api/fondo_disenio_general_update`;
  private endPointUpdateTipoFondoImage: string = `${this.domain}api/tipo_fondo_general_update`;
  private endPointGetBotonGalleryTema: string = `${this.domain}api/botones_galeria_list`;
  private endPointGetBotonGalleryModelo: string = `${this.domain}api/modelo_botones_list`;
  private endPointUpdateModeloBoton: string = `${this.domain}api/boton_disenio_general_update`;
  private endPointGetBotonGalleryModelo_retro: string = `${this.domain}api/modelo_botones_retroceder_list`;
  private endPointGetBotonGalleryTema_retro: string = `${this.domain}api/botones_galeria_retroceder_list`;
  private endPointUpdateModeloBotonRetro: string = `${this.domain}api/boton_retroceder_disenio_general_update`;

  private endPointSplashGame: string = `${this.domain}api/splash_disenio_list`;
  private endPointListIcons: string = `${this.domain}api/icono_carga_list`;
  private endPointSplashUpdate: string = `${this.domain}api/splash_disenio_update`;
  private endPointSplashFondoUpdate: string = `${this.domain}api/fondo_tipo_splash_update`;
  private endPointSplashImagenFondoUpdate: string = `${this.domain}api/fondo_splash_update`;
  private endPointSplashTipoLogo: string = `${this.domain}api/logo_tipo_splash_update`;
  private endPointSplashLogoImage: string = `${this.domain}api/logo_splash_update`;
  private endPointSplashTipoIconCarga: string = `${this.domain}api/icono_carga_tipo_splash_update`;
  private endPointSplashIconCarga: string = `${this.domain}api/icono_carga_update`;

  private endPointStartGame: string = `${this.domain}api/inicio_disenio_list`;
  private endPointStartFondoUpdate: string = `${this.domain}api/fondo_tipo_inicio_update`;
  private endPointStartImagenFondoUpdate: string = `${this.domain}api/fondo_inicio_update`;
  private endPointStartUpdate: string = `${this.domain}api/inicio_disenio_update`;
  private endPointStartTipoLogo: string = `${this.domain}api/logo_tipo_inicio_update`;
  private endPointStartLogoImage: string = `${this.domain}api/logo_inicio_update`;
  private endPointStartStatusMetodology: string = `${this.domain}api/metodologia_estado_update`;
  private endPointStartStatusCredit: string = `${this.domain}api/creditos_estado_update`;
  private endPointStartStatusNews: string = `${this.domain}api/reportajes_estado_update`;
  private endPointStartRedes: string = `${this.domain}api/redes_sociales_usuario_update`;
  private endPointStartRedStatus: string = `${this.domain}api/redes_sociales_estado_update`;
  //PANTALLA DE JUEGO
  private endPointScreenGame: string = `${this.domain}api/pantalla_juego_disenio_list`;
  private endPointScreenUpdate: string = `${this.domain}api/pantalla_juego_update`;
  private endPointListMarcoStyle: string = `${this.domain}api/galeria_estilo_marco_list`;
  private endPointListIconografias: string = `${this.domain}api/galeria_iconografias_list`;
  private endPointListFondoStyle: string = `${this.domain}api/galeria_estilo_fondo_list`;
  private endPointListFondoStyleColor: string = `${this.domain}api/galeria_color_estilo_list`;
  private endPointUpdateMarcoStyle: string = `${this.domain}api/estilo_marco_pantalla_juego_update`;
  private endPointUpdateIconografia: string = `${this.domain}api/iconografias_pantalla_juego_update`;
  private endPointUpdateFondoStyle: string = `${this.domain}api/estilo_fondo_pantalla_juego_update`;
  //PANTALLA MODAL
  private endPointModalGame: string = `${this.domain}api/pantalla_modal_disenio_list`;
  private endPointModalUpdate: string = `${this.domain}api/pantalla_modal_disenio_update`;
  //PANTALLA METODOLOGIA
  private endPointMetodologyGame: string = `${this.domain}api/metodologia_disenio_list`;
  private endPointMetodologyUpdate: string = `${this.domain}api/metodologia_disenio_update`;
  private endPointMetodologyUpdateImage: string = `${this.domain}api/subir_imagen_metodologia_update`;
  //PANTALLA CREDITOS
  private endPointCreditsGame: string = `${this.domain}api/creditos_disenio_list`;
  private endPointCreditsUpdate: string = `${this.domain}api/creditos_disenio_update`;
  private endPointCreditsUpdateImage: string = `${this.domain}api/subir_imagen_credito`;
  //PANTALLA REPORTAJES
  private endPointReportsGame: string = `${this.domain}api/reportajes_disenio_list`;
  private endPointReportsUpdate: string = `${this.domain}api/reportajes_disenio_update`;

  //PANTALLA CREAR HISTORIA JUEGO HISTORIA
  private endPointScenesHistory: string = `${this.domain}api/escenas_list`;
  private endPointCreateScenesHistory: string = `${this.domain}api/escenas_create`;
  private endPointDuplicateScenesHistory: string = `${this.domain}api/escenas_duplicate`;
  private endPointDeleteScenesHistory: string = `${this.domain}api/escenas_delete`;
  private endPointCharactaresScenesHistory: string = `${this.domain}api/avatarjh_list`;
  private endPointDeleteCharactares: string = `${this.domain}api/avatarjh_delete`;
  private endPointCharactaresCreateGalleryHistory: string = `${this.domain}api/avatarjh_create_archivo_galeria`;
  private endPointCharacterFile: string = `${this.domain}api/avatarjh_create_subiendo_archivo`;
  //MANTENIMIENDO DE FONDOS DE ESCENAS
  private endPointBackgruoundsScenesHistory: string = `${this.domain}api/fondos_escenas_list`;
  private endPointDeleteBackgrounds: string = `${this.domain}api/fondo_escena_delete`;
  private endPointBackgruoundsCreateGalleryHistory: string = `${this.domain}api/fondo_escena_archivo_galeria_create`;
  private endPointBackgruoundFile: string = `${this.domain}api/fondo_escena_archivo_subida_create`;
  private endPointUpdatefondo: string = `${this.domain}api/fondo_escena_update`;
  private endPointUpdateFE: string = `${this.domain}api/fondo_escenas_update`;
  private endPointUpdateST: string = `${this.domain}api/audio_escenas_update`;
  private endPointUpdateName: string = `${this.domain}api/nombre_escenas_update`;

  //Soundtracks
  private endPointSoundtracksScenesHistory: string = `${this.domain}api/audios_escenas_list`;
  private endPointDeleteSoundtracks: string = `${this.domain}api/audio_escena_delete`;
  private endPointSoudtracksGallery: string = `${this.domain}api/audios_busqueda`;
  private endPointcreateSoundtracksGallery: string = `${this.domain}api/audio_escena_archivo_galeria_create`;
  private endPointcreateSoundtracksGeneralGallery: string = `${this.domain}api/audio_disenio_update`;

  private endPointcreateSoundtracksFile: string = `${this.domain}api/audio_escena_archivo_subida_create`;
  private endPointcreateSoundtracksGeneralFile: string = `${this.domain}api/subir_audio_general`;

  private endPointUpdateSoundtracks: string = `${this.domain}api/audio_escena_update`;

  //GALERIA Y FILTRO AVATARES
  private endPointCharactaresGalleryScenesHistory: string = `${this.domain}api/avatar_list`;
  //GALERIA Y FILTRO FONDOS
  private endPointBackgroundsGalleryScenesHistory: string = `${this.domain}api/fondo_escena_list`;

  private endPointBgGalleryScenesHistory: string = `${this.domain}api/fondos_escenas_list`;
  private endPointSoundtracksGalleryScenesHistory: string = `${this.domain}api/audios_escenas_list`;

  private endPointStatesAvatars: string = `${this.domain}api/estado_avatarjh_list`;
  private endPointUpdateStatesAvatar: string = `${this.domain}api/avatar_campos_update`;
  private endPointDeleteStatesAvatar: string = `${this.domain}api/estado_avatarjh_delete`;

  //PANTALLA HISTORIA ACCIONES DIALOGO
  private endPointDialogCreate: string = `${this.domain}api/accion_dialogo_create`;
  private endPointDialogList: string = `${this.domain}api/accion_general_list`;  ///accion_dialogo_list
  private endPointDialogUpdate: string = `${this.domain}api/accion_dialogo_update`;
  private endPointDialogQuestionUpdate: string = `${this.domain}api/accion_pregunta_update`;
  private endPointDialogAnswerUpdate: string = `${this.domain}api/accion_respuesta_update`;
  private endPointDialogAnswerSceneUpdate: string = `${this.domain}api/accion_respuesta_escena_update`;


  private endPointDialogUpdateAvatar: string = `${this.domain}api/accion_dialogo_asignar_avatar_estado`;
  private endPointDialogDelete: string = `${this.domain}api/accion_dialogo_delete`;
  private endPointDialogQuestionDelete: string = `${this.domain}api/accion_pregunta_delete`;

  private endPointDialogQuestion: string = `${this.domain}api/accion_pregunta_create`;

  private endPointDialogVideo: string = `${this.domain}api/accion_video_create`;
  private endPointUpdateUrlVideo: string = `${this.domain}api/accion_video_update`;
  private endPointDeleteVideoAction: string = `${this.domain}api/accion_video_delete`;

  private endPointDialogImage: string = `${this.domain}api/accion_imagen_create`;
  private endPointUpdateImageAction: string = `${this.domain}api/accion_imagen_archivo_update`;
  private endPointDeleteImageAction: string = `${this.domain}api/accion_imagen_delete`;

  private endPointDialogAudio: string = `${this.domain}api/accion_audio_create`;
  private endPointDeleteAudioAction: string = `${this.domain}api/accion_audio_delete`;
  private endPointUpdateAudioAction: string = `${this.domain}api/accion_audio_update`;

  private endPointDialogFinal: string = `${this.domain}api/accion_escena_final_create`;
  private endPointListSceneFinal: string = `${this.domain}api/accion_escena_final_list`;
  private endPointUpdateDataSceneFinal: string = `${this.domain}api/accion_escena_final_update`;
  private endPointUpdateArchivoSceneFinal: string = `${this.domain}api/accion_escena_final_archivo_update`;
  private endPointSceneFinalUpdateAvatar: string = `${this.domain}api/accion_escena_final_avatar_update`;
  private endPointSceneFinalDelete: string = `${this.domain}api/accion_escena_final_delete`;

  //PANTALLA HISTORIA ACCION PREGUNTA
  private endPointQuestionList: string = `${this.domain}api/accion_pregunta_list`;







  //CONFIGURACION DE JUEGO
  private endPointValidarGame: string = `${this.domain}api/validate_directorio_game`;
  private endPointGenerateGame: string = `${this.domain}api/generar_juego`;
  private endPointGenerateGamePrevisualizacion: string = `${this.domain}api/generar__vista_previa`;
  private endPointGetInfoGame: string = `${this.domain}api/juego_list_id`;
  private endPointUpdateInfoGame: string = `${this.domain}api/juego_update`;
  private endPointUpdateImageGame: string = `${this.domain}api/juego_imagenes_update`;

  private endPointEmailHelp: string = `${this.domain}api/help_mail`;


  //MEMBRESIA
  private endPointMembershipPlans: string = `${this.domain}api/planes_list`;
  private endPointMembershipKey: string = `${this.domain}api/generate_key`;





  constructor(private http: HttpClient) { }

  getHeaderToken(token) {
    return {
      headers: new HttpHeaders({
        'Authorization': token
      })
    };
  }
  getHeaderJsonToken(token) {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
  }

  getHeaderFormDataToken(token) {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'multipart/form-data',
        'Accept': 'application/json',
        'Authorization': token
      })
    };
  }

  getDomain() {
    return this.domain;
  }


  /** user functions */
  validateUser(token) {
    return this.http.post(this.endPointUser, { "token": token }, this.httpOptions);
  }

  updateTerms(token, data) {
    let header = this.getHeaderJsonToken(token);

    return this.http.post(this.endPointTerms, data, header);
  }

  getProfileUser(token) {
    let header = this.getHeaderToken(token);

    return this.http.get(this.endPointProfile, header);
  }

  updateProfileUser(token, data) {
    let header = this.getHeaderJsonToken(token);

    return this.http.post(this.endPointUpdateProfile, data, header);
  }

  /** game functions */

  createGame(token, type) {
    let header = this.getHeaderToken(token);
    return this.http.post(`${this.endPointCreateGame}/${type}`, {}, header);
  }

  getListGames(token) {
    let header = this.getHeaderToken(token);

    return this.http.get(this.endPointListGames, header);
  }

  cloneGame(token, type) {
    let header = this.getHeaderToken(token);

    return this.http.get(`${this.endPointCloneGames}/${type}`, header);
  }

  deleteGame(token, type) {
    let header = this.getHeaderToken(token);

    return this.http.delete(`${this.endPointDeleteGame}/${type}`, header);
  }

  getDesignGeneral(token, id) {
    let header = this.getHeaderToken(token);

    return this.http.get(`${this.endPointDesignGeneralGame}/${id}`, header);
  }

  getFonts(token) {
    let header = this.getHeaderToken(token);

    return this.http.get(`${this.endPointFontsGame}`, header);
  }

  getStyleFonts(token) {
    let header = this.getHeaderToken(token);

    return this.http.get(`${this.endPointStyleFontsGame}`, header);
  }

  getIcons(token) {
    let header = this.getHeaderToken(token);

    return this.http.get(`${this.endPointListIcons}`, header);
  }

  getSizeFonts(token) {
    let header = this.getHeaderToken(token);

    return this.http.get(`${this.endPointSizeFontsGame}`, header);
  }

  updateDesignGeneral(token, idGame, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointUpdateDesignGeneralGame}/${idGame}`, data, header);
  }


  updateFondoDesignGeneral(token, idGame, formdata) {
    let header = this.getHeaderToken(token);
    return this.http.post(`${this.endPointUpdateFondoImage}/${idGame}`, formdata, header);
  }

  updateTipoFondoDesignGeneral(token, idGame, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointUpdateTipoFondoImage}/${idGame}`, data, header);
  }

  getGalleryButtonTema(token, idModelo) {
    let header = this.getHeaderToken(token);

    return this.http.get(`${this.endPointGetBotonGalleryTema}/${idModelo}`, header);
  }

  getGalleryButtonModelo(token) {
    let header = this.getHeaderToken(token);

    return this.http.get(`${this.endPointGetBotonGalleryModelo}`, header);
  }

  getGalleryButtonTemaRetro(token, idModelo) {
    let header = this.getHeaderToken(token);

    return this.http.get(`${this.endPointGetBotonGalleryTema_retro}/${idModelo}`, header);
  }

  getGalleryButtonModeloRetro(token) {
    let header = this.getHeaderToken(token);

    return this.http.get(`${this.endPointGetBotonGalleryModelo_retro}`, header);
  }

  updateBotonModelo(token, idGame, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointUpdateModeloBoton}/${idGame}`, data, header);
  }

  updateBotonModeloRetro(token, idGame, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointUpdateModeloBotonRetro}/${idGame}`, data, header);
  }

  // SPLASH

  getSplash(token, id) {
    let header = this.getHeaderToken(token);

    return this.http.get(`${this.endPointSplashGame}/${id}`, header);
  }

  updateCampoSplash(token, idGame, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointSplashUpdate}/${idGame}`, data, header);
  }

  updateSplashTipoFondo(token, idGame, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointSplashFondoUpdate}/${idGame}`, data, header);
  }

  updateSplashImageFondo(token, idGame, formdata) {
    let header = this.getHeaderToken(token);
    return this.http.post(`${this.endPointSplashImagenFondoUpdate}/${idGame}`, formdata, header);
  }

  updateSplashTipoLogo(token, idGame, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointSplashTipoLogo}/${idGame}`, data, header);
  }

  updateSplashImageLogo(token, idGame, formdata) {
    let header = this.getHeaderToken(token);
    return this.http.post(`${this.endPointSplashLogoImage}/${idGame}`, formdata, header);
  }

  updateSplashTipoIcono(token, idGame, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointSplashTipoIconCarga}/${idGame}`, data, header);
  }

  updateSplashIcono(token, idGame, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointSplashIconCarga}/${idGame}`, data, header);
  }

  // START
  getStart(token, id) {
    let header = this.getHeaderToken(token);
    return this.http.get(`${this.endPointStartGame}/${id}`, header);
  }
  updateStartTipoFondo(token, idGame, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointStartFondoUpdate}/${idGame}`, data, header);
  }

  updateStartImageFondo(token, idGame, formdata) {
    let header = this.getHeaderToken(token);
    return this.http.post(`${this.endPointStartImagenFondoUpdate}/${idGame}`, formdata, header);
  }

  updateCampoStart(token, idGame, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointStartUpdate}/${idGame}`, data, header);
  }

  updateStartTipoLogo(token, idGame, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointStartTipoLogo}/${idGame}`, data, header);
  }

  updateStartImageLogo(token, idGame, formdata) {
    let header = this.getHeaderToken(token);
    return this.http.post(`${this.endPointStartLogoImage}/${idGame}`, formdata, header);
  }

  updateStartStatusMetodology(token, idGame, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointStartStatusMetodology}/${idGame}`, data, header);
  }

  updateStartStatusCredits(token, idGame, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointStartStatusCredit}/${idGame}`, data, header);
  }

  updateStartStatusNews(token, idGame, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointStartStatusNews}/${idGame}`, data, header);
  }

  updateStartRedes(token, idGame, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointStartRedes}/${idGame}`, data, header);
  }

  updateStartStatusRedes(token, idGame, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointStartRedStatus}/${idGame}`, data, header);
  }

  // SCREEN GAME
  getScreen(token, id) {
    let header = this.getHeaderToken(token);
    return this.http.get(`${this.endPointScreenGame}/${id}`, header);
  }

  updateCampoScreen(token, idGame, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointScreenUpdate}/${idGame}`, data, header);
  }

  getListMarcoStyle(token) {
    let header = this.getHeaderToken(token);
    return this.http.get(this.endPointListMarcoStyle, header);
  }

  getListIconografias(token) {
    let header = this.getHeaderToken(token);
    return this.http.get(this.endPointListIconografias, header);
  }

  getListFondoStyle(token) {
    let header = this.getHeaderToken(token);
    return this.http.get(this.endPointListFondoStyle, header);
  }

  getListaEstilosFondoColores(token, idModelo) {
    let header = this.getHeaderToken(token);

    return this.http.get(`${this.endPointListFondoStyleColor}/${idModelo}`, header);
  }

  updateMarcoStyle(token, idGame, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointUpdateMarcoStyle}/${idGame}`, data, header);
  }

  updateIconografias(token, idGame, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointUpdateIconografia}/${idGame}`, data, header);
  }

  updateFondoStyle(token, idGame, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointUpdateFondoStyle}/${idGame}`, data, header);
  }

  // MODAL GAME
  getModal(token, id) {
    let header = this.getHeaderToken(token);
    return this.http.get(`${this.endPointModalGame}/${id}`, header);
  }

  updateCampoModal(token, idGame, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointModalUpdate}/${idGame}`, data, header);
  }

  // METODOLOGY GAME
  getMetodology(token, id) {
    let header = this.getHeaderToken(token);
    return this.http.get(`${this.endPointMetodologyGame}/${id}`, header);
  }

  updateCampoMetodology(token, idGame, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointMetodologyUpdate}/${idGame}`, data, header);
  }

  updateMetodologyImage(token, idGame, formdata) {
    let header = this.getHeaderToken(token);
    return this.http.post(`${this.endPointMetodologyUpdateImage}/${idGame}`, formdata, header);
  }

  // CREDITS GAME
  getCredits(token, id) {
    let header = this.getHeaderToken(token);
    return this.http.get(`${this.endPointCreditsGame}/${id}`, header);
  }

  updateCampoCredits(token, idGame, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointCreditsUpdate}/${idGame}`, data, header);
  }

  updateCreditsImage(token, idGame, formdata) {
    let header = this.getHeaderToken(token);
    return this.http.post(`${this.endPointCreditsUpdateImage}/${idGame}`, formdata, header);
  }

  // REPORTS GAME
  getReports(token, id) {
    let header = this.getHeaderToken(token);
    return this.http.get(`${this.endPointReportsGame}/${id}`, header);
  }

  updateCampoReports(token, idGame, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointReportsUpdate}/${idGame}`, data, header);
  }

  // ESCENAS LISTADO
  getScenes(token, id) {
    let header = this.getHeaderToken(token);
    return this.http.get(`${this.endPointScenesHistory}/${id}`, header);
  }
  getCreateScenes(token, id) {
    let header = this.getHeaderToken(token);
    return this.http.get(`${this.endPointCreateScenesHistory}/${id}`, header);
  }
  duplicateScenes(token, id) {
    let header = this.getHeaderToken(token);
    return this.http.get(`${this.endPointDuplicateScenesHistory}/${id}`, header);
  }

  deleteSceneHistory(token, id) {
    let header = this.getHeaderToken(token);
    return this.http.delete(`${this.endPointDeleteScenesHistory}/${id}`, header);
  }

  // LISTADO PERSONAJES ESCENAS

  getCharactaresScenes(token, id) {
    let header = this.getHeaderToken(token);
    return this.http.get(`${this.endPointCharactaresScenesHistory}/${id}`, header);
  }

  deleteCharactares(token, type) {
    let header = this.getHeaderToken(token);
    return this.http.delete(`${this.endPointDeleteCharactares}/${type}`, header);
  }
  //LISTADO DE FONDOS DE ESCENAS
  getBackgroundsScenes(token, id) {
    let header = this.getHeaderToken(token);
    return this.http.get(`${this.endPointBackgruoundsScenesHistory}/${id}`, header);
  }
  deleteBackgrounds(token, type) {
    let header = this.getHeaderToken(token);
    return this.http.delete(`${this.endPointDeleteBackgrounds}/${type}`, header);
  }
  //Soundtracks
  getSoundtracksScenes(token, id) {
    let header = this.getHeaderToken(token);
    return this.http.get(`${this.endPointSoundtracksScenesHistory}/${id}`, header);
  }
  deleteSoundtracks(token, type) {
    let header = this.getHeaderToken(token);
    return this.http.delete(`${this.endPointDeleteSoundtracks}/${type}`, header);
  }
  getSoundtracksGallery(token, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointSoudtracksGallery}`, data, header);
  }




  //PANTALLA HISTORIA ACCIONES DIALOGO
  createDialog(token, idScene, data) {
    let header = this.getHeaderToken(token);
    return this.http.post(`${this.endPointDialogCreate}/${idScene}`, data, header);
  }
  createDialogQuestion(token, idScene, data) {
    let header = this.getHeaderToken(token);
    return this.http.post(`${this.endPointDialogQuestion}/${idScene}`, data, header);
  }
  createDialogImage(token, idScene, data) {
    let header = this.getHeaderToken(token);
    return this.http.post(`${this.endPointDialogImage}/${idScene}`, data, header);
  }
  createDialogVideo(token, idScene, data) {
    let header = this.getHeaderToken(token);
    return this.http.post(`${this.endPointDialogVideo}/${idScene}`, data, header);
  }
  createDialogAudio(token, idScene, data) {
    let header = this.getHeaderToken(token);
    return this.http.post(`${this.endPointDialogAudio}/${idScene}`, data, header);
  }
  createDialogFinal(token, idScene, data) {
    let header = this.getHeaderToken(token);
    return this.http.post(`${this.endPointDialogFinal}/${idScene}`, data, header);
  }
  //  

  getDialogs(token, idScene) {
    let header = this.getHeaderToken(token);
    return this.http.get(`${this.endPointDialogList}/${idScene}`, header);
  }
  updateDialog(token, idDialog, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointDialogUpdate}/${idDialog}`, data, header);
  }
  updateDialogQuestion(token, idQuestion, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointDialogQuestionUpdate}/${idQuestion}`, data, header);
  }
  updateDialogAnswer(token, idAnswer, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointDialogAnswerUpdate}/${idAnswer}`, data, header);
  }
  updateDialogAnswerScene(token, idAnswer, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointDialogAnswerSceneUpdate}/${idAnswer}`, data, header);
  }


  updateDialogAvatar(token, idDialog, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointDialogUpdateAvatar}/${idDialog}`, data, header);
  }
  updateFE(token, id, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.put(`${this.endPointUpdateFE}/${id}`, data, header);
  }
  updateST(token, id, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.put(`${this.endPointUpdateST}/${id}`, data, header);
  }
  updateName(token, id, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.put(`${this.endPointUpdateName}/${id}`, data, header);
  }



  //PANTALLA HISTORIA ACCION PREGUNTA
  getQuestions(token, idScene) {
    let header = this.getHeaderToken(token);
    return this.http.get(`${this.endPointQuestionList}/${idScene}`, header);
  }
  //GAME CONFIGURACION
  generateGamePrevisualizacion(token, id) {
    let header = this.getHeaderToken(token);
    return this.http.get(`${this.endPointGenerateGamePrevisualizacion}/${id}`, header);
  }
  generateGame(token, id) {
    let header = this.getHeaderToken(token);
    return this.http.get(`${this.endPointGenerateGame}/${id}`, header);
  }
  valirarGame(token, id) {
    let header = this.getHeaderToken(token);
    return this.http.get(`${this.endPointValidarGame}/${id}`, header);
  }

  getInfoGame(token, id) {
    let header = this.getHeaderToken(token);
    return this.http.get(`${this.endPointGetInfoGame}/${id}`, header);
  }
  updateInfoGame(token, id, body) {
    let header = this.getHeaderToken(token);
    return this.http.put(`${this.endPointUpdateInfoGame}/${id}`, body, header);
  }
  updateImage(token, id, body) {
    let header = this.getHeaderToken(token);
    return this.http.post(`${this.endPointUpdateImageGame}/${id}`, body, header);
  }

  emailHelp(token, body) {
    let header = this.getHeaderToken(token);
    return this.http.post(`${this.endPointEmailHelp}`, body, header);
  }



  createCharactaresGallery(token, id, body) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointCharactaresCreateGalleryHistory}/${id}`, body, header);
  }
  createBackgroundsGallery(token, id, body) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointBackgruoundsCreateGalleryHistory}/${id}`, body, header);
  }
  createSoundtracksGallery(token, id, body) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointcreateSoundtracksGallery}/${id}`, body, header);
  }
  createSoundtracksGeneralGallery(token, id, body) {
    let header = this.getHeaderJsonToken(token);
    return this.http.post(`${this.endPointcreateSoundtracksGeneralGallery}/${id}`, body, header);
  }

  updateNameFondoEscene(token, id, body) {
    let header = this.getHeaderJsonToken(token);
    return this.http.put(`${this.endPointUpdatefondo}/${id}`, body, header);
  }
  updateNameSoundtrackEscene(token, id, body) {
    let header = this.getHeaderJsonToken(token);
    return this.http.put(`${this.endPointUpdateSoundtracks}/${id}`, body, header);
  }




  deleteDialogo(token, idDialog) {
    let header = this.getHeaderToken(token);
    return this.http.delete(`${this.endPointDialogDelete}/${idDialog}`, header);
  }
  deleteDialogoQuestion(token, idDialog) {
    let header = this.getHeaderToken(token);
    return this.http.delete(`${this.endPointDialogQuestionDelete}/${idDialog}`, header);
  }
  createCharacterFile(token, id, formdata) {
    let header = this.getHeaderToken(token);
    return this.http.post(`${this.endPointCharacterFile}/${id}`, formdata, header);
  }
  createBackgroundFile(token, id, formdata) {
    let header = this.getHeaderToken(token);
    return this.http.post(`${this.endPointBackgruoundFile}/${id}`, formdata, header);
  }
  createSoundtracksFile(token, id, formdata) {
    let header = this.getHeaderToken(token);
    return this.http.post(`${this.endPointcreateSoundtracksFile}/${id}`, formdata, header);
  }
  createSoundtracksGeneralFile(token, id, formdata) {
    let header = this.getHeaderToken(token);
    return this.http.post(`${this.endPointcreateSoundtracksGeneralFile}/${id}`, formdata, header);
  }




  //LISTADO DE AVATARES DE GALERIA
  getCharactaresGalleryScenes(token, data) {
    let header = this.getHeaderToken(token);
    return this.http.post(`${this.endPointCharactaresGalleryScenesHistory}`, data, header);
  }
  //LISTADO DE FONDOS DE GALERIA
  getBackgroundsGalleryScenes(token, data) {
    let header = this.getHeaderToken(token);
    return this.http.post(`${this.endPointBackgroundsGalleryScenesHistory}`, data, header);
  }

  getBgGalleryScenes(token, id) {
    let header = this.getHeaderToken(token);
    return this.http.get(`${this.endPointBgGalleryScenesHistory}/${id}`, header);
  }
  getSoundtracks(token, id) {
    let header = this.getHeaderToken(token);
    return this.http.get(`${this.endPointSoundtracksGalleryScenesHistory}/${id}`, header);
  }


  getStatesAvatars(token, idAvatar) {
    let header = this.getHeaderToken(token);
    return this.http.get(`${this.endPointStatesAvatars}/${idAvatar}`, header);
  }
  updateStatesAvatar(token, id, body) {
    let header = this.getHeaderToken(token);
    return this.http.put(`${this.endPointUpdateStatesAvatar}/${id}`, body, header);
  }
  //endPointDeleteStatesAvatar
  deleteStatesAvatar(token, idState) {
    let header = this.getHeaderToken(token);
    return this.http.delete(`${this.endPointDeleteStatesAvatar}/${idState}`, header);
  }


  //action video
  deleteActionVideo(token, idaction) {
    let header = this.getHeaderToken(token);
    return this.http.delete(`${this.endPointDeleteVideoAction}/${idaction}`, header);
  }
  updateUrlVideoAction(token, idaction, body) {
    let header = this.getHeaderToken(token);
    return this.http.put(`${this.endPointUpdateUrlVideo}/${idaction}`, body, header);
  }

  //action image
  updateImageAction(token, idaction, formdata) {
    let header = this.getHeaderToken(token);
    return this.http.post(`${this.endPointUpdateImageAction}/${idaction}`, formdata, header);
  }
  deleteActionImage(token, idaction) {
    let header = this.getHeaderToken(token);
    return this.http.delete(`${this.endPointDeleteImageAction}/${idaction}`, header);
  }
  //action audio
  updateAudioAction(token, idaction, formdata) {
    let header = this.getHeaderToken(token);
    return this.http.post(`${this.endPointUpdateAudioAction}/${idaction}`, formdata, header);
  }
  deleteActionAudio(token, idaction) {
    let header = this.getHeaderToken(token);
    return this.http.delete(`${this.endPointDeleteAudioAction}/${idaction}`, header);
  }

  //ACTION SCENE FINAL
  getActionSceneFinal(token, id) {
    let header = this.getHeaderToken(token);
    return this.http.get(`${this.endPointListSceneFinal}/${id}`, header);
  }
  updateArchivoSceneFinal(token, idfinal, formdata) {
    let header = this.getHeaderToken(token);
    return this.http.post(`${this.endPointUpdateArchivoSceneFinal}/${idfinal}`, formdata, header);
  }
  updateDataSceneFinal(token, id, body) {
    let header = this.getHeaderToken(token);
    return this.http.put(`${this.endPointUpdateDataSceneFinal}/${id}`, body, header);
  }
  updateSceneFinalAvatar(token, id, data) {
    let header = this.getHeaderJsonToken(token);
    return this.http.put(`${this.endPointSceneFinalUpdateAvatar}/${id}`, data, header);
  }
  deleteActionEsceneFinal(token, idaction) {
    let header = this.getHeaderToken(token);
    return this.http.delete(`${this.endPointSceneFinalDelete}/${idaction}`, header);
  }

  //MEMBRESIAS
  getPlanes(token, data) {
    let header = this.getHeaderToken(token);
    return this.http.post(`${this.endPointMembershipPlans}`, data, header);
  }
  //MEMBRESIAS
  getKey(token, data) {
    let header = this.getHeaderToken(token);
    return this.http.post(`${this.endPointMembershipKey}`, data, header);
  }


}